/* eslint-disable */
/* eslint-disable camelcase */
/* eslint-disable no-invalid-this */
//@ts-nocheck
import { NextPageContext } from 'next'
import Cookies from 'universal-cookie'
import Router from 'next/router'
import { fetchBootstrapData } from '../redux/store/actions/auth'
import {
  calculateBaseTimestamp,
  formatPersianDates,
  getTodayDate,
} from './dateManager'

/**
 * @function escapeOutput
 * @param {*} toOutput
 * @description prevents the xss in input
 * @return {string}
 */
export function escapeOutput(toOutput = '') {
  return toOutput
    .replace(/\&/g, '&amp;')
    .replace(/\</g, '&lt;')
    .replace(/\>/g, '&gt;')
    .replace(/\"/g, '&quot;')
    .replace(/\'/g, '&#x27')
    .replace(/\//g, '&#x2F')
}

export function makeUniqueId(length) {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const setIfNumber = (e, setFieldValue, max?) => {
  const val = toEnglish(e.target.value)

  if (!isNaN(Number(val))) {
    if (!max) {
      setFieldValue(val)
    } else {
      if (e.target.value.length <= max) {
        setFieldValue(val)
      }
    }
  }
}

export const toPersian = function (val) {
  if (val) {
    const id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
    return val.toString().replace(/[0-9]/g, function (w) {
      return id[+w]
    })
  } else {
    return val
  }
}

export const moneyFormat = function (val) {
  try {
    const re = '\\d(?=(\\d{' + 3 + '})+' + (3 > 0 ? '\\.' : '$') + ')'
    const value: string = val
      .toFixed(Math.max(0, ~~3))
      .replace(new RegExp(re, 'g'), '$&,')
    return value.slice(0, value.length - 4)
  } catch (e) {
    return ''
  }
}

export const underLine = function () {
  this.replace('/s/g', '_')
}

export const toEnglish = function (val) {
  const find = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  const replace = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  let replaceString = val
  let regex
  for (let i = 0; i < find.length; i++) {
    regex = new RegExp(find[i], 'g')
    replaceString = replaceString.replace(regex, replace[i])
  }
  return replaceString
}

export const dateFormatter = str => {
  return `${str.year}/${str.month}/${str.day}`
}

export const setCookie = (name, value, days = 100) => {
  const assign = name + '=' + value + ';'
  const d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString() + ';'
  const path = 'path=/;'
  let domain = ''
  if (document.domain.match(/[^\.]*\.[^.]*$/))
    domain = 'domain=' + document.domain.match(/[^\.]*\.[^.]*$/)[0] + ';'
  document.cookie = assign + expires + path + domain
}

export const setCookieSec = (name, value, sec = 100) => {
  const assign = name + '=' + value + ';'
  const d = new Date()
  d.setTime(d.getTime() + sec)
  const expires = 'expires=' + d.toUTCString() + ';'
  const path = 'path=/;'
  let domain = ''
  if (document.domain.match(/[^\.]*\.[^.]*$/))
    domain = 'domain=' + document.domain.match(/[^\.]*\.[^.]*$/)[0] + ';'
  document.cookie = assign + expires + path + domain
}

export const getCookie = cname => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function deleteCookie(name) {
  // document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  let domain = ''
  if (document.domain.match(/[^\.]*\.[^.]*$/))
    domain = 'domain=' + document.domain.match(/[^\.]*\.[^.]*$/)[0] + ';'
  document.cookie = name + '=; Max-Age=-99999999;' + ' path=/; ' + domain
}

export function trunc(s, n) {
  if (s) {
    return s.length > n ? s.substr(0, n - 1) + '...' : s
  } else {
    return ''
  }
}

export const accessToken = (ctx: NextPageContext): string | null => {
  let token = null
  const { req } = ctx

  if (req) {
    const cookies = new Cookies(req?.headers.cookie)
    token = cookies.get('logged-in')
  } else {
    token = getCookie('logged-in')
  }
  return token === 'true'
}
export const withAuth = (
  ctx: NextPageContext,
  nextUrl?: string,
): object | null => {
  if (!accessToken(ctx)) {
    if (ctx?.query?.token) {
      ;(ctx.res as any)?.redirect(
        `/autoLogin?token=${ctx.query?.token}${nextUrl ? `${nextUrl && `&next_url=${nextUrl}`}` : ''}`,
      )
    } else {
      ;(ctx.res as any)?.redirect(
        `/login${nextUrl ? `${nextUrl && `?next_url=${nextUrl}`}` : ''}`,
      )
    }
  }
  return {}
}

export const withHotelAuth = (ctx: NextPageContext, nextUrl?: string) => {
  const path = encodeURIComponent(nextUrl || 'hotels')
  withAuth(ctx, path)
  return { props: {} }
}

export const withFlightAuth = (ctx: NextPageContext, nextUrl?: string) => {
  const path = nextUrl || String(ctx.asPath || 'flight').replace(/^\//, '')
  withAuth(ctx, path)
  return { props: {} }
}

function calculateDaysDifference(jalaliDate) {
  // Parse the Jalali date (e.g., "1404-05-20")
  const [year, month, day] = jalaliDate.split('-').map(Number)

  // Get today's date in timestamp
  const todayDate = getTodayDate()

  // Convert Jalali date to timestamp
  const endDayTimestamp =
    calculateBaseTimestamp(year, month) + (day - 1) * 86400

  // Calculate the difference in days
  return Math.ceil((endDayTimestamp - todayDate.ts) / 86400) - 1
}
export const calendarSelector = (state, key = 'calendarData') => {
  let res: any = null

  if (state[key]) {
    const keys = Object.keys(
      state[key]?.calendar ? state[key]?.calendar : state[key],
    )
    const date = new Date()
    const convertedDat = formatPersianDates(date)
    const firstDayFormatted = formatPersianDates(date)

    const todayDate = {
      day: +firstDayFormatted.day,
      month: +firstDayFormatted.month,
      year: +firstDayFormatted.year,
      ts: date.getTime(),
    }
    const monthId = `${todayDate.year}-${
      todayDate.month < 10 ? '0' + todayDate.month : todayDate.month
    }`
    const dataToLoop = state[key].calendar
      ? state[key].calendar
      : state[key] || {}
    for (const date of keys) {
      if (!res) res = { calendar: {} }
      res.calendar[date] = dataToLoop[date]
    }

    res = { ...res, endDay: null }
    const currentMonth = `${monthId}`
    if (res.calendar) {
      let isInstantToday = false
      if (res?.calendar[currentMonth])
        isInstantToday = res?.calendar[currentMonth].filter(day => {
          if (day.day === todayDate.day) {
            return day.is_instant === true
          }
          return false
        })
      res.today = isInstantToday
    }
    if (state[key].end_day) res.endDay = state[key].end_day
    res.endDay = state[key].end_day || null
    let differenceInDays1 = 90
    let differenceInDays = 90
    if (res.endDay) {
      differenceInDays = calculateDaysDifference(state[key].end_day)
    }

    res.differenceInDays = differenceInDays
  }
  return res
}

export const getPropByString = (obj, propString) => {
  if (!obj) return
  if (!propString) return obj

  let prop
  const props = propString.split('.')

  let i
  let iLen
  for (i = 0, iLen = props.length - 1; i < iLen; i++) {
    prop = props[i]
    const candidate = obj[prop]
    if (candidate !== undefined) {
      obj = candidate
    } else {
      break
    }
  }
  if (!obj) obj = {}
  return obj[props[i]]
}

export const syncAppWithToken = async (dispatch: any, isRouterPush = true) => {
  try {
    setCookie('logged-in', 'true')
    await dispatch(fetchBootstrapData())
    isRouterPush && Router.push('/')
  } catch (err) {
    // Handle Err
  }
}

export function validateEmail(email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const addRecentSearch = item => {
  const obj = {}
  if (!item?.name?.trim()) {
    return
  }

  obj.name = item.name

  obj.type = item.type
  const lsArr = localStorage.getItem('recent-searches')
  let mainArr = lsArr ? [...JSON.parse(lsArr), obj] : [obj]

  mainArr = mainArr
    .reverse()
    .filter(
      (item, index, self) =>
        index === self.findIndex(t => t.name === item.name),
    )
    .reverse()
  localStorage.setItem(
    'recent-searches',
    JSON.stringify(mainArr.length > 3 ? mainArr.slice(1, 5) : mainArr),
  )
}

// TODO this function should use every where
// Search.tsx, HomeSearch.tsx, Header.tsx
// Refactor needed
export const handleClickRecent = (
  cityName: string,
  type: string = 'city',
  data: any = {},
) => {
  const query: any = {}

  const txtItem = {
    date: '',
    name: cityName,
    type,
    checkin: data?.checkin,
    checkout: data?.checkout,
  }

  if (+cityName) {
    txtItem.type = 'phrase'
  }

  addRecentSearch(txtItem)

  if (data.checkin && data.checkout) {
    query.checkin = data.checkin
    query.checkout = data.checkout
  }

  const {
    routes,
    special_discount,
    special_discount_city,
    pecial_discount_province,
    ['user_co_ordinates[longitude]']: userCoordinatesLongitude,
    ['user_co_ordinates[latitude]']: userCoordinatesLatitude,
    co_ordinates,
    page,
    near_cities,
    from_map_nearby,
    mid_term,
    ...restQueries
  } = txtItem.type === 'phrase'
    ? { phrase: txtItem.name, ...Router.query }
    : query.checkin && query.checkout
      ? {
          checkin: query.checkin,
          checkout: query.checkout,
          ...Router.query,
        }
      : {
          ...Router.query,
        }

  setTimeout(() => {
    Router.push({
      pathname:
        txtItem.type === 'phrase' ? `/search` : `/search/${type}/${cityName}`,
      query: restQueries,
    })
  }, 0)
}

export const getParsedDateByTimeStamp = (
  date: string | number | null,
): string => {
  if (!date) return null
  const convertedDate = new Date(date * 1000)
  const localeDate = convertedDate.toLocaleDateString('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    numberingSystem: 'latn',
  })
  const formattedDate = localeDate.replace(/\//g, '-')
  return formattedDate
}

export const isInStandaloneMode = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone ||
  document.referrer?.includes('android-app://')

export const getOSName = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  const userAgent = window.navigator.userAgent.toLowerCase()
  const safari = /safari/.test(userAgent)
  const ios = /iphone|ipod|ipad/.test(userAgent)

  if (ios) {
    if (safari) {
      // Safari
      return 'web'
    } else if (!safari) {
      // IOS
      return 'ios'
    }
  } else {
    if (isInStandaloneMode()) {
      // Android
      return 'android'
    } else {
      // Any other webpage
      return 'web'
    }
  }
}

/**
 * handles fetching bootstrap data and some useragent parsing
 * @param {object} dispatch
 */
export const initializeOptions = dispatch => {
  dispatch(fetchBootstrapData())
}

export const newDateTimeFormat = (date: string | number) => {
  const todayDate = getTodayDate()

  if (todayDate.year - (getParsedDateByTimeStamp(date).split('-')[0] as any)) {
    return getParsedDateByTimeStamp(date)
  } else if (
    todayDate.year - (getParsedDateByTimeStamp(date).split('-')[0] as any) ===
    0
  ) {
    if (
      todayDate.month - (getParsedDateByTimeStamp(date).split('-')[1] as any)
    ) {
      return ` ${
        todayDate.month - (getParsedDateByTimeStamp(date).split('-')[1] as any)
      } ماه قبل`
    } else if (
      todayDate.day - (getParsedDateByTimeStamp(date).split('-')[2] as any)
    )
      return `  ${
        todayDate.day - (getParsedDateByTimeStamp(date).split('-')[2] as any)
      } روز قبل `
    else return ' امروز'
  }
}

export const scrollToElement = el => {
  const offset = 180
  const bodyRect = document.body.getBoundingClientRect().top
  const elementRect = el?.getBoundingClientRect().top
  const elementPosition = elementRect - bodyRect
  const offsetPosition = elementPosition - offset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })
}

export const convertUrlToParamsObject: any = url => {
  function paramsToObject(entries) {
    const result = {}
    for (const [key, value] of entries) {
      result[key] = value
    }
    return result
  }

  const urlParams = new URLSearchParams(
    url?.includes('?') && url.includes('=') ? url.split('?')[1] : url,
  )
  const entries = urlParams.entries()

  return paramsToObject(entries)
}

export const createSearchStableQueries = () => {
  const queries = {}

  const { query } = Router
  if (query.checkin && query.checkout) {
    queries.checkin = query.checkin
    queries.checkout = query.checkout
  }

  if (query.guests) {
    queries.guests = query.guests
  }
  return queries
}

export function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData('Text', text)
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported('copy')
  ) {
    const textarea = document.createElement('textarea')
    textarea.textContent = text
    textarea.style.position = 'fixed' // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea)
    textarea.select()
    try {
      return document.execCommand('copy') // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex)
      return prompt('Copy to clipboard: Ctrl+C, Enter', text)
    } finally {
      document.body.removeChild(textarea)
    }
  }
}
